/** @file Multiplies the light alpha of a chunk's vertices by an opacity (the ghost's translucency). */
import { RENDER_LAYOUT } from '@pose2d/geometry/renderBuffers';
import type { RenderBuffers } from '@pose2d/geometry/types';
import { scaleAlpha } from '@pose2d/overlay/draw/scaleAlpha';

/** Word 4 of a vertex is its light colour (RenderBuffers: x, y, u, v, light, dark). */
const LIGHT_WORD = 4;

/** Scales the light alpha of the chunk's `vertexCount` vertices by `opacity` (clamped 0..1); bumps `version`. */
export function fadeChunk(chunk: RenderBuffers, opacity: number): void {
  const words = chunk.vertexU32;
  for (let v = 0; v < chunk.vertexCount; v++) {
    const at = v * RENDER_LAYOUT.VERTEX_WORDS + LIGHT_WORD;
    words[at] = scaleAlpha(words[at] ?? 0, opacity);
  }
  chunk.version += 1;
}
